<template>
  <base-label :class="labelClass" :for="name">
    {{ label }}
      <select
        :name="name"
        :value="modelValue"
        @input="$emit('update:modelValue', ($event.target as HTMLSelectElement).value)"
        v-bind="$attrs"
        class="block p-3 h-12 bg-white border rounded-sm custom-caret"
        :class="{
          'text-gray-400': modelValue === null,
          'mt-2 sm:mt-4': label
          }"
      >
        <option v-if="placeholder" :disabled="!allowEmpty" value>
          {{ placeholder }}
        </option>
        <option
          v-for="option in countryCodeOptions"
          :value="option.code"
          :key="option.code"
        >
          {{ option.label }}
        </option>
      </select>
  </base-label>
</template>

<script setup lang="ts">
import { customList } from 'country-codes-list';
import { computed } from 'vue';

defineOptions({
  inheritAttrs: false,
})

const props = withDefaults(
  defineProps<{
    modelValue?: string | null
    allowEmpty?: boolean
    placeholder?: string | boolean
    label?: string
    labelClass?: string | string[]
  }>(),
  {
    allowEmpty: true,
    placeholder: 'Select',
    label: 'Country Code',
  }
)

defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

// Generate country code options from the country-codes-list package
const countryCodesData = customList(
  'countryCallingCode',
  '{countryCallingCode}|{countryNameEn}'
)

// Convert to array of unique dial codes
const countryCodeOptions = computed(() => {
  const dialCodes = new Set<string>()

  for (const callingCode of Object.keys(countryCodesData)) {
    dialCodes.add(`+${callingCode}`)
  }

  // Sort numerically
  return Array.from(dialCodes)
    .map((code) => ({ code, label: code }))
    .sort((a, b) => {
      const numA = parseInt(a.code.replace('+', ''))
      const numB = parseInt(b.code.replace('+', ''))
      return numA - numB
    })
})

const name = computed(() => props.label?.toLowerCase().replace(/\s+/g, '-'))
</script>
